import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }

import { onMounted, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowWordByWord',
  props: {
  text: {
    type: String,
    required: true
  }
},
  emits: ['ShowWordByWord:finished'],
  setup(__props, { emit: __emit }) {

const props = __props;

watch(
  () => props.text,
  (newValue) => {
    if (newValue) {
      wordIndex.value = 0;
      words.value = newValue?.match(/(\S+|\n)/g);
      const visibleElements = document.querySelectorAll('.visible');

      visibleElements.forEach((element) => {
        element.classList.remove('visible');
      });
      startWordByWord();
    }
  }
);

const wordIndex = ref(0);
const words = ref([]);
const emit = __emit;

function finished() {
  emit('ShowWordByWord:finished');
}
function startWordByWord() {
  const interval = setInterval(() => {
    if (wordIndex.value !== undefined && wordIndex.value < words.value.length) {
      const wordElement = document.getElementsByClassName(
        `word-num__${wordIndex.value}`
      )[0];

      if (wordElement) {
        wordElement.classList.add('visible');
      }
      wordIndex.value++;
    } else {
      clearInterval(interval);
      finished();
    }
  }, 250);
}

onMounted(() => {
  words.value = props.text.match(/(\S+|\n)/g);
  startWordByWord();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(words.value, (word, index) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
      (word.endsWith('\n'))
        ? (_openBlock(), _createElementBlock("br", _hoisted_1))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(`game-dialog__dialog-text word-num__${index}`)
          }, _toDisplayString(word) + "  ", 3))
    ], 64))
  }), 128))
}
}

})